'use client';

import type { ReactNode } from 'react';

import { Toaster } from './Toaster';

export function ToastProvider({ children }: { children: ReactNode }) {
  return (
    <>
      {children}
      <Toaster />
    </>
  );
}
